import { useEffect } from "react";
import "../../../styles/publicForm.css";

/**
 * Holds the document still while a screen that may not scroll is up.
 *
 * The splash and the two welcomes are exactly the height of the window and
 * have nothing under the fold to reach — see `fit` on `PublicFormShell`. They
 * already clip what does not fit. What they could not do for themselves is
 * stop the *page* moving: on iOS, `overflow: hidden` on an element says
 * nothing about the document, and Safari will pan and spring a document that
 * has nothing to scroll to at all. A greeting that gives under the thumb and
 * snaps back reads as a page that is broken, on the one screen whose whole job
 * is to look like it was meant.
 *
 * What the class does is in `publicForm.css`, where the three rules it takes
 * on that browser are written out. Here is only when it is worn.
 *
 * Off again the moment the screen changes — pressing Let's begin leaves a form
 * of fourteen questions that is taller than any phone, and locking that would
 * be a far worse bug than the one this fixes. `active` rather than a mount, so
 * a shell that stays put while its `fit` turns off unlocks with it.
 */
const useNoDocumentScroll = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;

    const root = document.documentElement;
    root.classList.add("form-page-locked");
    return () => root.classList.remove("form-page-locked");
  }, [active]);
};

export default useNoDocumentScroll;
